import { get } from "lodash";
import { MyInfo, MyInfoWithDOD } from "./MyInfo.model";
import { LoanTypeEnum } from "../enum/loan-type.enum";
import { FlatRoomTypeEnum } from "../enum/flat-room-type.enum";
import { HoldingTypeEnum } from "../enum/holding-type.enum";
import { LoanStatusInfo } from "./LoanStatusInfo.model";
import { FlatTypeInfo } from "./FlatTypeInfo.model";
import { HoldingTypeInfo } from "./HoldingTypeInfo.model";
import { SalesCodeTypeEnum } from "../enum/sales-code-type.enum";
import { PolymerCrypto } from "../../utils/encryptor";
import { Helpers } from "../../utils/helper";



export class SMSInfo {
  
  financing_info         : PropertyFinancingInfo;
  flat_type              : FlatRoomTypeEnum | undefined;
  holding_type           : HoldingTypeEnum | undefined;
  eligibility_scheme_code: string | undefined;

  constructor(initial?:any){
    this.financing_info        = get(initial, 'financing_info', new PropertyFinancingInfo(initial));
    this.flat_type             = get(initial, "flat_type"     , undefined)
    this.holding_type          = get(initial, "holding_type"  , undefined)
    this.eligibility_scheme_code = get(initial, "eligibility_scheme_code", "");
  }

  setFinancingInfo(value: LoanStatusInfo){
    let currentLoanType = value.loan_type_code;
    const loanAmount = value.outstanding_loan_balance_amt ? Number(value.outstanding_loan_balance_amt) : 0;
    if(currentLoanType === LoanTypeEnum.hdb_loan && !isNaN(loanAmount) && loanAmount === 0){
        currentLoanType = LoanTypeEnum.no_loan;
    }
    this.financing_info = new PropertyFinancingInfo({
      current_loan_type: currentLoanType,
      current_loan_amount: value.loan_type_code === LoanTypeEnum.bank_loan ? 0 : value.outstanding_loan_balance_amt.toString(),
      current_loan_date: value.loan_balance_date,
      sales_type_code: value.sales_type_code,
      num_months_in_arrears_or_advance: value.num_months_in_arrears_or_advance,
      estate_action_code: value.estate_action_code,
      has_current_outstanding_loan: value.outstanding_loan_balance_amt ? Helpers.formatStringToNumber(value.outstanding_loan_balance_amt.toString()) > 0 : false
    })
  }
  setFlatType(value: FlatTypeInfo){
    this.flat_type = value.flat_type_code as FlatRoomTypeEnum;
  }
  setHoldingType(value: HoldingTypeInfo){
    this.holding_type = value.holding_type 
  }
  setEligibilitySchemeCode(value: string){
    this.eligibility_scheme_code = value;
  }

  json(){
    return this;
  }
}

export class Properties extends SMSInfo {
  
  hdb_ref                : string;
  role                   : string;
  no_of_owners           : number;
  owners                 : MyInfoWithDOD[];
  occupiers              : MyInfo[];
  address                : string;
  main_applicant_uinfin  : string;
  additional_roles       : MyInfoWithDOD[];

  constructor(initial?:any){
    super(initial);
    this.hdb_ref               = get(initial, 'hdb_ref'       , "");
    this.role                  = get(initial, 'role'          , "");
    this.no_of_owners          = get(initial, 'no_of_owners'  , 0);
    this.owners                = get(initial, 'owners'        , []);
    this.occupiers             = get(initial, 'occupiers'     , []);
    this.address               = get(initial, 'address'       , "");
    this.main_applicant_uinfin = get(initial, 'main_applicant_uinfin', "");
    this.additional_roles      = get(initial, 'additional_roles', []);
  }


  decryptOwnersOccupiersAdditionalRoles(){
    this.owners = this.owners.map(e=>{
      return {...e, email: PolymerCrypto.decryption(e.email), uinfin: PolymerCrypto.decryption(e.uinfin), mobile_no: PolymerCrypto.decryption(e.mobile_no)}
    })  
    
    this.occupiers = this.occupiers.map(e=>{
      return {...e, email: PolymerCrypto.decryption(e.email), uinfin: PolymerCrypto.decryption(e.uinfin), mobile_no: PolymerCrypto.decryption(e.mobile_no)}
    })  
    
    this.additional_roles = this.additional_roles.map(e=>{
      return {...e, email: PolymerCrypto.decryption(e.email), uinfin: PolymerCrypto.decryption(e.uinfin), mobile_no: PolymerCrypto.decryption(e.mobile_no)}
    })  
  }

}



export class PropertyFinancingInfo{
  current_loan_type   : LoanTypeEnum | undefined;
  current_loan_amount : string;
  current_loan_date   : string;
  num_months_in_arrears_or_advance :any
  sales_type_code?   : SalesCodeTypeEnum | undefined;
  estate_action_code : string;
  has_current_outstanding_loan? : boolean
  constructor(initial?: any){
    this.current_loan_type   = get(initial, "current_loan_type", undefined);
    this.current_loan_amount = get(initial, "current_loan_amount", 0)
    this.current_loan_date   = get(initial, "current_loan_date", '')
    this.sales_type_code     = get(initial, "sales_type_code", undefined)
    this.num_months_in_arrears_or_advance     = get(initial, "num_months_in_arrears_or_advance", 0)
    this.estate_action_code  = get(initial, "estate_action_code", "")
    this.has_current_outstanding_loan  = get(initial, "has_current_outstanding_loan", false)
  }
}
